import { Box, Typography } from "@mui/material";
import { FC } from "react";
import { Colors } from "../../../styles/constant";
import { tabViewPoint } from "../../../utils/constants";

interface Props {
  title: string[];
  subTitle: string[];
  isMobile: boolean;
  image: string;
  height: number;
}

const LoginStartupTitle: FC<Props> = ({
  title,
  subTitle,
  isMobile,
  image,
  height,
}) => {
  return (
    <>
      {isMobile ? (
        // <Box flexGrow={1} display="flex" justifyContent="center">
        //   <img
        //     src={image}
        //     width="110%"
        //     style={{ maxWidth: "25rem" }}
        //     height={height < tabViewPoint ? `${height - 360}px)` : "auto"}
        //   />
        // </Box>
        <Box flexGrow={1} display="flex" overflow="hidden">
          <img
            src={image}
            width="100%"
            style={{
              maxWidth: "28rem",
              transform: height < tabViewPoint ? "none" : "scale(1.1)",
              margin: "0 auto",
            }}
          />
        </Box>
      ) : (
        <Box display="grid" justifyContent="center" marginTop="1rem">
          <img
            src={image}
            width="100%"
            height={height < tabViewPoint ? `${height - 360}px)` : "auto"}
          />
        </Box>
      )}
      <Box
        display="flex"
        gap={isMobile ? "1rem" : ".75rem"}
        flexDirection="column"
        alignItems="center"
        textAlign="center"
        paddingX={isMobile ? "2rem" : "4.5rem"}
        marginTop={isMobile ? undefined : "1rem"}
      >
        <Typography
          color={Colors.red}
          fontSize={isMobile ? 28 : 22}
          fontWeight={600}
          lineHeight={isMobile ? "2.1rem" : "1.65rem"}
        >
          <span style={{ color: "black" }}>{title[0]}</span> {title[1]} <br />
          {title[2]}
        </Typography>
        <Typography variant={isMobile ? "h4" : "h5"}>
          <span style={{ fontWeight: 500 }}>
            {subTitle[0]} <br />
            {subTitle[1]}
          </span>
          {subTitle[2]}
        </Typography>
      </Box>
    </>
  );
};

export default LoginStartupTitle;
